export default {
    namespaced: true,
    state: {
        // 用户名正则（长度4~12位，字母、数字或下划线，需以字母开头）
        username: /^[A-Za-z]\w{3,11}$/,
        // 昵称正则（长度2~12位，可包含中文、字母、数字或下划线）
        nickname: /^([\u4e00-\u9fa5]|\w){2,12}$/,
        // 密码正则（8~16位，且同时包含字母和数字，字母区分大小写）
        password: /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,16})$/,
        // 电话正则
        phone: /^[0-9+-]*$/,
        // 手机号正则（1开头的11位数字）
        // mobile: /^1[0-9]{10}$/,
        // 手机号正则（3~16位数字）
        mobile: /^\d{3,16}$/,
        // 邮箱正则
        email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
        // qq正则（1开头5~12位）
        qq: /^[1-9]\d{4,11}$/,
        // 金额正则 0~9开头 最多2位小数
        money: /^(([1-9]\d*)|0)(\.\d{0,2})?$/,
        // 身份证正则
        IDNumber: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    }
};
